/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import { Typography, Card, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from '@mui/material';
import BackButton from '../BackButton';
import cameraheight1 from '../../../../../../assets/images/ArticleImages/1.jpg';
import cameraheight2 from '../../../../../../assets/images/ArticleImages/2.jpg';
import Login from '../../../../../../assets/images/ArticleImages/Login.png';
import Dashboard from '../../../../../../assets/images/ArticleImages/dashboard.png';
import Register1 from '../../../../../../assets/images/ArticleImages/register1.png';
import Register2 from '../../../../../../assets/images/ArticleImages/register2.png';
import Remote1 from '../../../../../../assets/images/ArticleImages/remote1.png';
import Remote2 from '../../../../../../assets/images/ArticleImages/remote2.png';
import ROI from '../../../../../../assets/images/ArticleImages/ROI.jpg';
import Distance from '../../../../../../assets/images/ArticleImages/distance.jpg';
import fcwroi from '../../../../../../assets/images/ArticleImages/FcwRoi.jpg';
import vehiclewidth from '../../../../../../assets/images/ArticleImages/vehiclewidth.jpg';
import livestream from '../../../../../../assets/images/ArticleImages/livestream.png';
import DownloadIcon from '@mui/icons-material/Download'; // Import the Download icon

// Define a type for the content blocks
type ContentBlock =
    | { type: 'heading'; value: string; variant?: 'h4' | 'h5' | 'h6' | 'subtitle2'; style?: React.CSSProperties }
    | { type: 'paragraph'; value: string; style?: React.CSSProperties }
    | { type: 'image'; src: string; alt?: string; style?: React.CSSProperties }
    | { type: 'table'; rows: { category: string; feature: string; description: string }[] }
    | { type: 'image-row'; images: Array<{ src: string; alt?: string; style?: React.CSSProperties }> }; // Fixed type definition

const NovusSafePro: React.FC = () => {
    // Page header information
    const title = "Novus Safe Pro Specifications & Installation Manual";

    // Define the content of your article as a list of blocks.
    const contentBlocks: ContentBlock[] = [
        {
            type: 'heading',
            value: "Product Overview",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'paragraph',
            value: "Novus Pro is an AI-powered system for real-time video telematics, ADAS, and driver monitoring, designed to enhance fleet safety and operational efficiency. It features highcomputational AI processing with edge inference, enabling low-latency event detection and real-time decision-making. Supporting four camera inputs (Cabin, Forward, Blind Spot, RearView), it provides multi-angle perception and integrates Bluetooth-enabled sensors for extended functionality. The ADAS module includes Forward Collision Warning (FCW), Lane Departure Warning (LDW), Pedestrian Collision Warning (PCW), and Blind Spot Monitoring (BSM), ensuring proactive risk mitigation. The Driver Monitoring System (DMS) detects seat belt compliance, drowsiness, distractions, phone usage, and smoking, enhancing driver accountability. With secure cloud storage, OTA firmware updates, and API interoperability, Novus Pro offers seamless integration with fleet management systems, ensuring comprehensive safety, compliance, and real-time situational awareness",
        },
        {
            type: 'heading',
            value: "Features List",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'table',
            rows: [
                { category: "", feature: "Forward collision warning", description: "Alerts the driver when an impending collision with a vehicle ahead is detected based on the vehicle’s speed and the distance to the object." },
                { category: "", feature: "Pedestrian collision warning", description: "Warns the driver if a pedestrian is detected in the path of the vehicle, to prevent a collision." },
                { category: "", feature: "Lane departure warning", description: "Notifies the driver when the vehicle begins to drift out of its current lane." },
                { category: "", feature: "Drowsiness warning", description: "Alerts the driver if signs of fatigue or drowsiness are detected." },
                { category: "", feature: "Distraction warning", description: "Issued when the driver is not looking at the road for an extended period." },
                { category: "", feature: "Phone use warning", description: "Activated when the driver is using a mobile phone while the vehicle is in motion." },
                { category: "", feature: "Smoking warning", description: "Alerts if the driver is detected smoking in the vehicle." },
                { category: "", feature: "Yawning warning", description: "Alerts the driver when yawning is detected, indicating potential fatigue." },
                { category: "", feature: "Seatbelt warning", description: "Notifies when the driver or passengers are detected not wearing seat belts while the vehicle is moving." },
                { category: "", feature: "Camera obstruction warning", description: "Issued when the view of any system camera is blocked, affecting its functionality." },
                { category: "", feature: "Low visibility alert", description: "Health data when the front camera is blocked." },
                { category: "", feature: "Over speeding alert", description: "Alerts the driver when the vehicle exceeds the set speed limit." },
                { category: "", feature: "Continues driving alert", description: "3 hours continue driving without stoppage for at least 30 minutes." },
                { category: "", feature: "Night driving alert", description: "Vehicle speed greater than 7kmph for more than 15 minutes between 11 pm and 6 am." },
                { category: "", feature: "Harsh acceleration alert", description: "Sudden acceleration with a speed increase of 15kmph/s" },
                { category: "", feature: "Harsh turning alert", description: "Change angle of more than 15 degrees at a speed greater than 25kmph" },
                { category: "", feature: "Harsh braking alert", description: "Sudden break with speed decrease of 15kmph/s" },
                { category: "", feature: "Sudden stoppage", description: "Harsh braking followed by the vehicle stopping for more than 5 minutes. (chances of accidents)" },
                { category: "", feature: "Vehicle idling alert", description: "Vehicle Ignition ON + Vehicle Speed at 0 kmph" },
                { category: "", feature: "FOV error detection", description: "Field of view error for cabin camera upon hinderance in camera angle" },
            ],
        },
        {
            type: 'heading',
            value: "Specifications",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },

        {
            type: 'table',
            rows: [
                { category: "Main Features", feature: "Operating System", description: "Android" },
                { category: "", feature: "Processor main frequency", description: "Quad Core ARM Processor" },
                { category: "", feature: "GPU/NPU", description: "Available" },
                { category: "", feature: "Supported video formats", description: "H264" },
                { category: "", feature: "Supported audio formats", description: "AAC" },
                { category: "", feature: "G Sensor", description: "Available" },
                { category: "Front camera", feature: "FOV", description: "Wide Angle Camera > 120°" },
                { category: "", feature: "Pixels", description: "Maximum Support 1920*1080" },
                { category: "", feature: "Video frame rate", description: "1080p@30fps" },
                { category: "Inward-facing camera", feature: "FOV", description: "Wide Angle Camera > 140°" },
                { category: "", feature: "Pixels", description: "Maximum Support 1280*720" },
                { category: "", feature: "Resolution", description: "720p@30fps" },
                { category: "Other", feature: "Wi-Fi", description: "2.4GHz（802.11 b/g/n）" },
                { category: "", feature: "Built-in speaker", description: "Support, mono, Max 90db" },
                { category: "", feature: "Built-in Mic", description: "Yes" },
                { category: "", feature: "Bluetooth", description: "Available" },
                { category: "", feature: "Storage", description: "SD Card Upto 512 GB" },
                { category: "Working environment", feature: "Working Voltage", description: "12/24 Volts" },
                { category: "", feature: "Operating temperature", description: "–20℃ to 70℃" },
                { category: "", feature: "Storage temperature", description: "-20～80℃" },
                { category: "Network", feature: "4G LTE", description: "BAND2/4/5/7/28" },
                { category: "", feature: "", description: "BAND 38/39/40/41(100Mhz)" },
                { category: "", feature: "WCDMA", description: "BAND 2/5" },
                { category: "", feature: "GSM", description: "GSM 850/1900MHz" },
            ],
        },
        {
            type: 'heading',
            value: "Installation Manual",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'paragraph',
            value: (
                <>
                    ► <strong>Tools Required for Installation</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Novus Pro Unit Power Cable",
        },
        {
            type: 'paragraph',
            value: "• Electric Tape",
        },
        {
            type: 'paragraph',
            value: "• Multimeter",
        },
        {
            type: 'paragraph',
            value: "• Wire Cutter",
        },
        {
            type: 'paragraph',
            value: "• Cable Tie",
        },
        {
            type: 'paragraph',
            value: "• 3M Tape",
        },
        {
            type: 'paragraph',
            value: "• Measuring Tape",
        },
        {
            type: 'paragraph',
            value: "• Alcohol Wipe* (To clean the windshield before fixing Novus Unit).",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    ► <strong>Power Cable Connections</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Red - Power (+Ve Battery)",
        },
        {
            type: 'paragraph',
            value: "• Yellow - Ignition (ACC)",
        },
        {
            type: 'paragraph',
            value: "• lack - -Ve (Ground)",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    ► <strong>Measurement and Fixing of camera on vehicle wind shield.</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Camera location and vehicle measurement can affect the device performance. It is very important to install Novus Pro device at right and correct location",
        },
        {
            type: 'paragraph',
            value: "• Try to install Novus device in middle of the vehicle covering complete cabin view. The unit should not block drivers view to road.",
        },
        {
            type: 'image',
            src: cameraheight1,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '100%', height: 'auto', borderRadius: 12 },
        },
        {
            type: 'paragraph',
            value: "• Measure the height of the camera installed from the surface as shown in the image below.",
        },
        {
            type: 'image',
            src: cameraheight2,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '80%', height: '60%', borderRadius: 12 },
        },
        {
            type: 'paragraph',
            value: "• Make sure the vision of ICC and FCW is clear and no obstruction should be there.",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    ► <strong>Device Registration and calibration by Installation Application</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <span style={{ color: 'red' }}>
                    Currently we have only android version of installation application
                </span>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Login Page- Login by using your login id and password",
        },
        {
            type: 'image-row',
            images: [
                {
                    src: Login,
                    alt: "Login Page",
                    style: { margin: '24px 0', width: '30%', height: '20%', borderRadius: 12 },
                },
                {
                    src: Dashboard,
                    alt: "Dashboard Page",
                    style: { margin: '24px 0', width: '30%', height: '20%', borderRadius: 12 },
                },
            ],
        },
        {
            type: 'paragraph',
            value: "• When the user clicks on the Device Registration icon, the following page will appear, allowing them to fill in the required details, use the scanner for the device, and submit the form by clicking the button.",
        },
        {
            type: 'image-row',
            images: [
                {
                    src: Register1,
                    alt: "Login Page",
                    style: { margin: '24px 0', width: '30%', height: '20%', borderRadius: 12 },
                },
                {
                    src: Register2,
                    alt: "Dashboard Page",
                    style: { margin: '24px 0', width: '30%', height: '20%', borderRadius: 12 },
                },
            ],
        },
        {
            type: 'paragraph',
            value: (
                <>
                    ► <strong>Remote Config</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• At the bottom of the dashboard page, there is a Remote Config button. When you click on it, the user will be redirected to the Remote Config page, as shown below.",
        },
        {
            type: 'image-row',
            images: [
                {
                    src: Remote1,
                    alt: "Login Page",
                    style: { margin: '24px 0', width: '30%', height: '20%', borderRadius: 12 },
                },
                {
                    src: Remote2,
                    alt: "Dashboard Page",
                    style: { margin: '24px 0', width: '30%', height: '20%', borderRadius: 12 },
                },
            ],
        },
        {
            type: 'paragraph',
            value: "Here, the user can fill in all the details",
        },
        {
            type: 'paragraph',
            value: "For example:",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>• Select Company:</strong> novus-hitech
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>• Select User:</strong> NOVUSTEST
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>• Select Device Type:</strong> fcw
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>• Select Device ID:</strong> 346430012345
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    ► <strong>Parameter</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Calb Front Camera FOE Y =</strong> Select it on the warning video
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Steps to get Calb Front Camera FOE Y</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Go to the Check Device page.",
        },
        {
            type: 'paragraph',
            value: "• Enter Customer Name: NOVUSTEST.",
        },
        {
            type: 'paragraph',
            value: "• Enter Device Number: 346430012345.",
        },
        {
            type: 'paragraph',
            value: "• Click on the Events Video icon.",
        },
        {
            type: 'paragraph',
            value: "• Click on the video frame where you want to select the Vanishing point (VP). A red dot will appear where you have clicked. Below, you will see the selected coordinates.",
        },
        {
            type: 'image',
            src: ROI,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '60%', height: '40%', borderRadius: 12 },
        },
        {
            type: 'paragraph',
            value: "• Click on OK to send the selected data to the database.",
        },
        {
            type: 'paragraph',
            value: (
                <span style={{ color: 'red' }}>
                    IF OPEN AREA IS NOT AVAILABLE AND WE ARE NOT ABLE TO SEE VANISHING POINT ON ROAD, WE CAN SET FOV BY BELOW METHOD.
                </span>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Take the vehicle to a location where there is something available at front of the vehicle. It can be a wall, another truck, poll, tree, etc. (This wall, poll etc should be between 5 to 7 meters from vehicle)",
        },
        {
            type: 'paragraph',
            value: "• It should be on the same level or surface as the vehicle.",
        },
        {
            type: 'paragraph',
            value: "• Fix or place a mark on wall at the same height as the camera height as per below image.",
        },
        {
            type: 'image',
            src: Distance,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '60%', height: '40%', borderRadius: 12 },
        },
        {
            type: 'paragraph',
            value: "• In video frame, there will be a yellow line between 2 red lines, align the Mark on wall at the yellow line and click to appear red dot",
        },
        {
            type: 'image',
            src: fcwroi,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '30%', height: '20%', borderRadius: 12 },
        },
        {
            type: 'paragraph',
            value: "Click on OK to send the selected data to the database.",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>• Camera Height =</strong> Vehicle Camera Mount Height (m)
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>• To left wheel =</strong> Vehicle Left Tyre to Camera (m)
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>• To right wheel =</strong> Vehicle Right Tyre to Camera (m)
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>• To bumper =</strong> Distance from Lens to the Visible Point (m)
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>• Vehicle width =</strong> FCW Subject Vehicle Width (m)
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>m = Meter</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <span style={{ color: 'red' }}>
                    If vehicle width &gt; 2 m, please enable ‘ldw_is_wide_body’ .
                </span>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• After filling in all the details, when the user clicks on the SUBMIT button, a confirmation screen will open with a Transaction ID. This ID helps to check the data in the database, as shown below.",
        },
        {
            type: 'image',
            src: vehiclewidth,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '60%', height: '40%', borderRadius: 12 },
        },
        {
            type: 'heading',
            value: "Live Stream",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'paragraph',
            value: "• Select the customer name and device ID for which you want to view the live stream video, and click the search button. After that, click on FCW or DSM, depending on which camera you want to view the video from. You can also set the ROI from the live stream.",
        },
        {
            type: 'image',
            src: livestream,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '30%', height: '20%', borderRadius: 12 },
        },
        {
            type: 'heading',
            value: "For FCW",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'paragraph',
            value: "• When the user clicks on FCW, the screen below will open, where you can view the live stream. You can click on the screen to set the ROI. After clicking OK, the ROI will be set.",
        },
        {
            type: 'image',
            src: fcwroi,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '30%', height: '20%', borderRadius: 12 },
        },
        {
            type: 'heading',
            value: "For DSM",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'paragraph',
            value: "• When the user clicks on DSM, the screen below will open, where you can view the live stream. Click on Start ROI, and a rectangle box will appear. Move the box to the area where you want to set the ROI, and then click OK to set the ROI.",
        },
        {
            type: 'heading',
            value: "Device INFO",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'paragraph',
            value: "• Here, users can select any device for any customer and view its details, such as where it is installed, its last location, and all other relevant information.",
        },
        {
            type: 'paragraph',
            value: (
                <span style={{ color: 'red' }}>
                    AFTER COMPLETE INSTALLATION, PLEASE TEST EVENTS BY MOVING VEHICLE FOR SOME KM & TRY TO GENERATE FEW EVENTS FOR DMS & FCW.
                </span>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <span style={{ color: 'red' }}>
                    Disclaimer: Please ensure that there is no preexisting ‘Vanishing Point File’ on the device.
                </span>
            ) as unknown as string,
        },
        {
            type: 'heading',
            value: "Attendance",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'paragraph',
            value: "• In the Attendance section, the user can see the current date calendar.",
        },
        {
            type: 'paragraph',
            value: "• When the user clicks on Clock-in, they will navigate to the Confirm Clock-in page where they will see their current location along with the current date and time, as shown in the image",
        },
        {
            type: 'paragraph',
            value: "• When the user clicks on confirm clock-in, a timer will start, as shown in the image.",
        },
        {
            type: 'paragraph',
            value: "• When the user clicks on Clock-Out, they will navigate to the Confirm Clock-out page where they will see their current location along with the current date and time, as shown in the image.",
        },
        {
            type: 'paragraph',
            value: "• When the user clicks on confirm clock-out, the timer will stop and display the total time the user was clocked in, as shown in the image.",
        },
        {
            type: 'paragraph',
            value: "• When the user clicks on the at the top left of the dashboard page, a side menu will open as shown in the image below.",
        },
        {
            type: 'paragraph',
            value: "• On the Attendance page, the user can view their clock-in and clock-out times along with their effective hours, as shown in the image below.",
        },
        {
            type: 'paragraph',
            value: "• When the user clicks on the history icon, they can see their attendance logs, including the details of how many times they clocked in and out, along with the corresponding clock-in and clock-out addresses, as shown in the image below.",
        },
        {
            type: 'paragraph',
            value: (
                <span style={{ color: 'red' }}>
                    Note:
                </span>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <span style={{ color: 'red' }}>
                    1.) If the user forgets to clock in, they will automatically be marked as Absent for that
                    day.
                </span>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <span style={{ color: 'red' }}>
                    2.) If the user clocks in but forgets to clock out by 23:59:59, they will automatically be marked as "Swipe Missed Out" for that day.
                </span>
            ) as unknown as string,
        },
        {
            type: 'heading',
            value: "Simple troubleshooting",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'table',
            rows: [
                { category: "Problems :", feature: "Answers :", description: "" },
                { category: "Recording invalid", feature: "Please use a FAT32, read/write speed≥C10 class memory card.", description: "" },
                { category: "Loop recording is invalid", feature: "Please check whether the memory card has enough space for recording, if not format the memory card.", description: "" },
                { category: "The video recording is blurry", feature: "Please remove the protective film from the camera lens and clean the lens and windshield.", description: "" },
                { category: "There is no audio on the footage", feature: "Make sure you have audio recording turned ON.", description: "" },
                { category: "The device temperature is too high", feature: "The AI function of the device requires a lot of calculation during operation, so it is normal to cause heat in the body, especially in the area of the heat sink. Please do not touch the heat sink to avoid burning.", description: "" },
                { category: "The file on the memory card cannot be displayed on the computer", feature: "Please change the video player to play. If it still does not work, the memory card may be damaged, please try to format or replace a new memory card.", description: "" },
                { category: "Other", feature: "If the above failure still does not resolve, please restore all settings to factory settings, or contact tech support for more help.", description: "" },
            ],
        },
        {
            type: 'heading',
            value: "Do’s and Don’ts",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'heading',
            value: "Do’s",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Choose a Good Mounting Location</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Mount the device behind the rearview mirror for minimal obstruction.",
        },
        {
            type: 'paragraph',
            value: "• Ensure the device has a clear view of the road ahead/ in-cabin driver view captures essential details without any blind spots.",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Install with a Secure Power Connection</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Use a direct power connection to the vehicle’s fuse box or a cigarette lighter adapter to avoid draining the car’s battery when the engine is off.",
        },
        {
            type: 'paragraph',
            value: "• Consider hardwiring the device for a cleaner setup and to prevent cable clutter.",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Route Cables Neatly</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Take wires along the edges of the windshield or behind panels to avoid obstruction and keep the interior looking neat.",
        },
        {
            type: 'paragraph',
            value: "• Secure cables with clips or adhesive pads to prevent them from interfering with airbags or other car systems.",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Check Legal Requirements</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Be aware of the device laws in your region regarding privacy and the placement of the camera. For example, some areas restrict dashcam installation where it could obstruct your view or where it might be illegal to record audio.",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Test Functionality After Installation</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Test the device before driving to ensure it is recording properly and capturing the desired view and generating proper alarms/ events.",
        },
        {
            type: 'paragraph',
            value: "• Check the camera settings and parameters settings before leaving the installation site.",
        },
        {
            type: 'paragraph',
            value: "• Switch the device on TEST MODE to test the device on parking condition.",
        },
        {
            type: 'paragraph',
            value: "• Make sure the TEST MODE is off when you leave the installation site/ vehicle.",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Update Firmware Regularly</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Check for software or firmware updates to ensure your device is operating with the latest features and improvements.",
        },
        {
            type: 'heading',
            value: "Don’ts",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Don’t Block Your Field of View</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Avoid placing the device in a position that obstructs your vision, such as directly in front of the driver or covering critical parts of the windshield.",
        },
        {
            type: 'paragraph',
            value: "• Never block sensors or cameras used for advanced driver-assistance systems (ADAS)/ Driver Monitoring System (DMS).",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Don’t Leave Cables Loose</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Never let cables hang loosely or dangle where they could interfere with the steering wheel or other controls.",
        },
        {
            type: 'paragraph',
            value: "• Avoid running cables across the airbag area, as it could be hazardous in the event of a crash.",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Don’t Use the Dashcam as a Backup Camera</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• The device is not meant to replace your rearview or backup cameras. Use it to record while driving, but don't rely on it for rearview visibility.",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Don’t Use Excessive Power</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Avoid using cheap or poorly made power adapters that may not provide consistent voltage, which can lead to malfunction or damage to the device.",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Don’t Record Audio Without Permission:</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Be aware of local laws regarding audio recording. In some areas, recording conversations (even within your car) can be illegal without consent.",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Don’t Ignore Regular Maintenance</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Don’t forget to check your device regularly for signs of malfunction or outdated software. You should also ensure the lens is clean and unobstructed.",
        },
        {
            type: 'paragraph',
            value: (
                <>
                    <strong>Don’t Overlook Storage</strong>
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "• Use high-quality microSD cards with sufficient capacity and speed to store footage without errors. Avoid using old or cheap memory cards that could cause data corruption or reduced recording performance.",
        },
    ];
    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = '../../../../../../assets/sampleFile/NovusSafePro.pdf'; // Replace with the actual path to your PDF file
        link.download = 'NovusSafePro_Document.pdf'; // Name of the downloaded file
        link.click();
    };
    // Function to render each content block based on its type.
    const renderContentBlock = (block: ContentBlock, index: number) => {
        switch (block.type) {
            case 'heading':
                return (
                    <Typography
                        key={index}
                        variant={block.variant || 'h4'}
                        style={{ fontWeight: 600, ...block.style }}
                    >
                        {block.value}
                    </Typography>
                );
            case 'paragraph':
                return (
                    <Typography
                        key={index}
                        variant="body1"
                        style={{
                            fontSize: '16px',
                            fontWeight: 400,
                            lineHeight: '24px',
                            ...block.style,
                        }}
                    >
                        {block.value}
                    </Typography>
                );
            case 'image':
                return (
                    <Card
                        key={index}
                        style={{
                            overflow: 'hidden',
                            borderRadius: 12,
                            ...block.style,
                        }}
                    >
                        <img
                            src={block.src}
                            alt={block.alt || 'Article image'}
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                    </Card>
                );
            case 'image-row':
                return (
                    <div
                        key={index}
                        style={{
                            display: 'flex',
                            gap: '15px',
                            width: '100%',
                        }}
                    >
                        {block.images.map((image, imgIndex) => (
                            <Card
                                key={imgIndex}
                                style={{
                                    overflow: 'hidden',
                                    borderRadius: 12,
                                    ...image.style,
                                }}
                            >
                                <img
                                    src={image.src}
                                    alt={image.alt || 'Article image'}
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                />
                            </Card>
                        ))}
                    </div>
                );
            case 'table':
                // Check if the table is for Features List
                if (block.rows[0]?.feature && !block.rows[0]?.category) {
                    return (
                        <TableContainer
                            key={index}
                            component={Paper}
                            style={{
                                border: '1px solid #ccc',
                                borderRadius: '8px',
                                overflow: 'hidden',
                            }}
                        >
                            <Table style={{ borderCollapse: 'collapse' }}>
                                <TableHead>
                                    <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                                        <TableCell
                                            style={{
                                                fontWeight: 600,
                                                border: '1px solid #ccc',
                                                textAlign: 'center',
                                                padding: '8px',
                                            }}
                                        >
                                            Feature
                                        </TableCell>
                                        <TableCell
                                            style={{
                                                fontWeight: 600,
                                                border: '1px solid #ccc',
                                                textAlign: 'center',
                                                padding: '8px',
                                            }}
                                        >
                                            Description
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {block.rows.map((row, rowIndex) => (
                                        <TableRow key={rowIndex}>
                                            <TableCell
                                                style={{
                                                    border: '1px solid #ccc',
                                                    textAlign: 'left',
                                                    padding: '8px',
                                                    fontWeight: 400,
                                                }}
                                            >
                                                {row.feature}
                                            </TableCell>
                                            <TableCell
                                                style={{
                                                    border: '1px solid #ccc',
                                                    textAlign: 'left',
                                                    padding: '8px',
                                                    fontWeight: 400,
                                                }}
                                            >
                                                {row.description}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    );
                }
                // Check if the table is for Specifications or Troubleshooting
                else if (block.rows[0]?.category) {
                    const isTroubleshooting = block.rows.every(row => row.description === "");

                    return (
                        <TableContainer
                            key={index}
                            component={Paper}
                            style={{
                                border: '1px solid #ccc',
                                borderRadius: '8px',
                                overflow: 'hidden',
                            }}
                        >
                            <Table style={{ borderCollapse: 'collapse' }}>
                                {!isTroubleshooting && (
                                    <TableHead>
                                        <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                                            <TableCell
                                                style={{
                                                    fontWeight: 600,
                                                    border: '1px solid #ccc',
                                                    textAlign: 'center',
                                                    padding: '8px',
                                                }}
                                            >
                                                Category
                                            </TableCell>
                                            <TableCell
                                                style={{
                                                    fontWeight: 600,
                                                    border: '1px solid #ccc',
                                                    textAlign: 'center',
                                                    padding: '8px',
                                                }}
                                            >
                                                Feature
                                            </TableCell>
                                            <TableCell
                                                style={{
                                                    fontWeight: 600,
                                                    border: '1px solid #ccc',
                                                    textAlign: 'center',
                                                    padding: '8px',
                                                }}
                                            >
                                                Description
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                )}
                                <TableBody>
                                    {block.rows.map((row, rowIndex) => (
                                        <TableRow key={rowIndex}>
                                            <TableCell
                                                style={{
                                                    border: '1px solid #ccc',
                                                    textAlign: 'left',
                                                    padding: '8px',
                                                    fontWeight: 400,
                                                }}
                                            >
                                                {row.category}
                                            </TableCell>
                                            <TableCell
                                                style={{
                                                    border: '1px solid #ccc',
                                                    textAlign: 'left',
                                                    padding: '8px',
                                                    fontWeight: 400,
                                                }}
                                            >
                                                {row.feature}
                                            </TableCell>
                                            {/* Only show description column if not troubleshooting */}
                                            {!isTroubleshooting && (
                                                <TableCell
                                                    style={{
                                                        border: '1px solid #ccc',
                                                        textAlign: 'left',
                                                        padding: '8px',
                                                        fontWeight: 400,
                                                    }}
                                                >
                                                    {row.description}
                                                </TableCell>
                                            )}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    );
                } else {
                    // Render Troubleshooting table
                    return (
                        <TableContainer
                            key={index}
                            component={Paper}
                            style={{
                                border: '1px solid #ccc',
                                borderRadius: '8px',
                                overflow: 'hidden',
                            }}
                        >
                            <Table style={{ borderCollapse: 'collapse' }}>
                                <TableHead>
                                    <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                                        <TableCell
                                            style={{
                                                fontWeight: 600,
                                                border: '1px solid #ccc',
                                                textAlign: 'center',
                                                padding: '8px',
                                            }}
                                        >
                                            Problems
                                        </TableCell>
                                        <TableCell
                                            style={{
                                                fontWeight: 600,
                                                border: '1px solid #ccc',
                                                textAlign: 'center',
                                                padding: '8px',
                                            }}
                                        >
                                            Answers
                                        </TableCell>
                                        {/* Render the Description header only if at least one row has a non-empty description */}
                                        {block.rows.some(row => row.description.trim() !== "") && (
                                            <TableCell
                                                style={{
                                                    fontWeight: 600,
                                                    border: '1px solid #ccc',
                                                    textAlign: 'center',
                                                    padding: '8px',
                                                }}
                                            >
                                                Description
                                            </TableCell>
                                        )}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {block.rows.map((row, rowIndex) => (
                                        <TableRow key={rowIndex}>
                                            <TableCell
                                                style={{
                                                    border: '1px solid #ccc',
                                                    textAlign: 'left',
                                                    padding: '8px',
                                                    fontWeight: 400,
                                                }}
                                            >
                                                {row.category}
                                            </TableCell>
                                            <TableCell
                                                style={{
                                                    border: '1px solid #ccc',
                                                    textAlign: 'left',
                                                    padding: '8px',
                                                    fontWeight: 400,
                                                }}
                                            >
                                                {row.feature}
                                            </TableCell>
                                            {/* Render the Description column only if it is not empty */}
                                            {row.description.trim() !== "" && (
                                                <TableCell
                                                    style={{
                                                        border: '1px solid #ccc',
                                                        textAlign: 'left',
                                                        padding: '8px',
                                                        fontWeight: 400,
                                                    }}
                                                >
                                                    {row.description}
                                                </TableCell>
                                            )}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    );
                }
            default:
                return null;
        }
    };

    return (
        <div className="flex flex-col w-full">
            <BackButton />

            <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', alignItems: 'center' }}>
                {/* Header Section */}
                <div
                    style={{
                        width: '100%',
                        maxWidth: '766px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '16px',
                    }}
                >
                    {/* Title & Tag Section */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <Typography variant="h4" style={{ fontWeight: 600 }}>
                            {title}
                        </Typography>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                                gap: '8px',
                            }}
                        >
                        </div>
                    </div>
                </div>

                {/* Content Section */}
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '16px',
                        width: '100%',
                        maxWidth: '766px',
                        padding: '16px 0',
                    }}
                >
                    {contentBlocks.map((block, index) => renderContentBlock(block, index))}
                </div>

                 {/* Download Button */}
                {/* <div style={{ textAlign: 'center', marginTop: '24px' }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleDownload}
                        style={{ padding: '10px 20px', fontSize: '16px' }}
                        startIcon={<DownloadIcon />} // Add the download icon here
                    >
                        Download Document
                    </Button>
                </div> */}

            </div>
        </div>
    );
};

export default NovusSafePro;